export default __webpack_public_path__ + "static/media/icon_branding.2226b9be.svg";